import AuthLayout from "@/components/AuthLayout"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"

interface Props {
  token: string
  alert: string | null
  notice: string | null
}

function getCsrfToken() {
  return document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? ""
}

export default function ResetPasswordPage({ token, alert, notice }: Props) {
  return (
    <AuthLayout
      title="Restablecer contraseña"
      subtitle="Ingresa y confirma tu nueva contraseña"
      alert={alert}
      notice={notice}
    >
      <form method="post" action={`/passwords/${token}`} className="flex flex-col gap-6">
        <input type="hidden" name="authenticity_token" value={getCsrfToken()} />
        <input type="hidden" name="_method" value="put" />

        <div className="flex flex-col gap-3">
          <Label htmlFor="password">Nueva contraseña</Label>
          <Input
            id="password"
            name="password"
            type="password"
            autoComplete="new-password"
            autoFocus
            required
            maxLength={72}
            placeholder="••••••••"
          />
        </div>

        <div className="flex flex-col gap-3">
          <Label htmlFor="password_confirmation">Confirmar nueva contraseña</Label>
          <Input
            id="password_confirmation"
            name="password_confirmation"
            type="password"
            autoComplete="new-password"
            required
            maxLength={72}
            placeholder="••••••••"
          />
        </div>

        <Button type="submit" className="w-full">
          Restablecer contraseña
        </Button>

        <a
          href="/session/new"
          className="text-center text-sm text-muted-foreground underline-offset-4 hover:underline hover:text-foreground"
        >
          ← Volver al inicio de sesión
        </a>
      </form>
    </AuthLayout>
  )
}
